import React, { PropTypes } from 'react';
import UnpinnedPointItem from './UnpinnedPointItem';
import { pointId } from '../reducers/point';

const UnpinnedPointList = ({
  points,
  onAddPoint,
  onDisplayPoint,
  taskType,
  disabled,
}) => (
  <div className="ui segments">
    <div className="ui clearing segment">
      <strong>Postes non placés</strong>
      {!disabled && (
        <button
          className="ui right floated mini labeled icon button"
          onClick={onAddPoint}
        >
          <i className="icon add" />
          Ajouter un commentaire
        </button>
      )}
    </div>
    {points.map(p => (
      <UnpinnedPointItem
        key={pointId(p)}
        point={p}
        onDisplay={onDisplayPoint}
        taskType={taskType}
      />
    ))}
  </div>
);

UnpinnedPointList.propTypes = {
  points: PropTypes.array.isRequired,
  onAddPoint: PropTypes.func.isRequired,
  onDisplayPoint: PropTypes.func.isRequired,
  taskType: PropTypes.string.isRequired,
};

export default UnpinnedPointList;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/zones/plan/components/UnpinnedPointList.js